import axios from 'axios'
export const getPoi = () => axios.get(`/rimet//fe/mtp/poi/customer/stat/list`, {
    params: {}
})

export const getPoiSales = (queryParms) => axios.get(`rimet/fe/mtp/poi/customer/stat`,{
    params: queryParms
})

export const getPoiSalesInProvince = (queryParms) => axios.get(`rimet//fe/mtp/poi/customer/stat/province`, {
    params: queryParms
})
export const getPoiSalesInProvinceCity = (queryParms) => axios.get(`rimet//fe/mtp/poi/customer/stat/city`, {
    params: queryParms
})





// WEBPACK FOOTER //
// ./src/api/customerSourceAnalyse.js